import React, { ElementType, PropsWithChildren } from 'react';
import { BoxProps } from '@cp/ds/src/components/box';
import { FormField } from '@cp/ds/src/components/form';
import { styled } from '@cp/ds/src/theme';
import { Collapse } from '@cp/ui';
import { Stack } from '@cp/ds/src/components/stack';
import { useFormContext } from 'react-hook-form';
import { Typography } from '@cp/ds/src/components/typography';
import { PaymentCardModel } from '../model';

const name = 'PaymentCardForm';
const Root = styled('form', { name })(({ theme }) => ({
  borderWidth: 0,
  marginInline: 0,
  borderRadius: '12px',
  overflow: 'hidden',
  padding: `${theme.spacing(2)} ${theme.spacing(1.5)}`,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
  backgroundColor: theme.palette['gray middle'],
}));

export interface PaymentCardFormProps extends PropsWithChildren, BoxProps {
  id?: string;
  collapsable?: boolean;
  as?: ElementType;
}
export const PaymentCardForm: React.FC<PaymentCardFormProps> = ({ collapsable, children, ...props }) => {
  const form = useFormContext<PaymentCardModel>();
  const [expanded, setExpanded] = React.useState(!collapsable);
  const expDateInputRef = React.useRef<HTMLInputElement>(null);
  const cvvInputRef = React.useRef<HTMLInputElement>(null);
  form.watch((_, info) => {
    if (info.name === 'cardNumber' && info.type === 'change') {
      form.trigger(info.name).then((valid) => {
        if (valid) {
          form.setFocus('expDate');
        }
      });
    } else if (info.name === 'expDate' && info.type === 'change') {
      form.trigger('expDate').then((valid) => {
        if (valid) {
          form.setFocus('cvv');
        }
      });
    }
  });
  return (
    <Root noValidate {...props}>
      <Typography sx={{ display: 'block', '&:empty': { display: 'none' }, color: 'red' }} variant="caption">
        {form.formState.errors.root?.message}
      </Typography>
      <FormField
        fieldLabel="Номер карты"
        hideErrorMessage
        name="cardNumber"
        onValidnessStateChange={(valid) => valid && setExpanded(true)}
        type="cardNumber"
      />
      <Collapse open={expanded}>
        <Stack direction="row" spacing={2.5} sx={{ justifyContent: 'space-between' }}>
          <FormField fieldLabel="Срок действия" hideErrorMessage name="expDate" ref={expDateInputRef} type="cardExpiration" />
          <FormField fieldLabel="CVC" hideErrorMessage name="cvv" ref={cvvInputRef} type="cvc" />
        </Stack>
      </Collapse>
      {children}
    </Root>
  );
};
PaymentCardForm.displayName = `entities/paymentMethod/${name}`;
